module.exports = __webpack_public_path__ + "media/images/ceremony/plans/2/hall-list/plan-ceremony-lineup-kanto-2-3be9155e773e2b7f65780aaead8d13a9.png";